
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:AccountPage:Loaded', function(event){
     setInterval(function(){
       var data = event.detail;
       Flits.shopCountryName = 'Italy';
       Flits('.flits-back-btn').each(function(index, ele){
         Flits(ele).attr('href', 'avascript:void(0);')
       })
     },1000);
  });
  
   Flits(document).on("click", ".flits-back-btn", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    Flits('body').removeClass('unloading');
    Flits(".flits-account-page-container").toggleClass("flits-active"), (location.hash = "");
    window.setTimeout((function() {
      return false;
    }), 50);
    return false;
  });

  // function flitsCustomIntregation(){
  //   var lion_integrated_page =Flits(".flits-custom-lion-page").children().children();
  //   Flits("#flits_tab_carta-fedelta .flits-tab-box-body").append(lion_integrated_page);
  //   Flits(".flits-custom-lion-page").remove();
  // }
  function flitsRiseRewarCustomIntregation(){
    var integrated_page =Flits(".flits-custom-rise-rewardpage").children();
    Flits("#flits_tab_carta-fedelta .flits-tab-box-body").append(integrated_page);
    Flits(".flits-custom-rise-rewardpage").remove();
  }
  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setTimeout(function(){
      // flitsCustomIntregation();
      flitsRiseRewarCustomIntregation();
    },1000);   
  });
}(Flits));
